(function () {
  // ─── GUARD : évite la double exécution si la section est re-rendue ────────
  if (window._deliveryCountdownRunning) return;
  window._deliveryCountdownRunning = true;

  var jours = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'];
  var mois = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];

  // ─── DEADLINE : localStorage (persiste entre sessions) ───────────────────
  var STORAGE_KEY = 'delivery-deadline';
  var storedDeadline = localStorage.getItem(STORAGE_KEY);
  var deadline;

  if (storedDeadline) {
    deadline = new Date(parseInt(storedDeadline));
    if (deadline <= new Date()) {
      deadline = generateDeadline();
    }
  } else {
    deadline = generateDeadline();
  }

  function generateDeadline() {
    var randomMinutes = Math.floor(Math.random() * (180 - 65 + 1) + 65);
    var d = new Date(Date.now() + randomMinutes * 60 * 1000);
    localStorage.setItem(STORAGE_KEY, d.getTime());
    return d;
  }

  // ─── DATE DE LIVRAISON ────────────────────────────────────────────────────
  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  var delivery = addBusinessDays(new Date(), 3);
  var formattedDate = jours[delivery.getDay()] + ' ' + delivery.getDate() + ' ' + mois[delivery.getMonth()];

  // ─── IDs ciblés (PDP + drawer) ───────────────────────────────────────────
  var TIMER_IDS = ['delivery-timer', 'delivery-timer-drawer'];
  var DATE_IDS  = ['delivery-date',  'delivery-date-drawer'];

  function fillAll() {
    DATE_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.dataset.filled) {
        el.textContent = formattedDate;
        el.dataset.filled = '1';
      }
    });
  }

  function updateTimers() {
    var now  = new Date();
    var diff = deadline - now;

    if (diff <= 0) {
      deadline = generateDeadline();
      diff = deadline - now;
    }

    var hours   = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);
    var text = (hours > 0 ? hours + 'h ' : '')
             + String(minutes).padStart(2, '0') + 'min '
             + String(seconds).padStart(2, '0') + 's';

    TIMER_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = text;
    });

    fillAll();
  }

  // ─── MutationObserver : zéro flash via rAF ───────────────────────────────
  var mutationScheduled = false;
  var observer = new MutationObserver(function () {
    if (mutationScheduled) return;
    mutationScheduled = true;
    requestAnimationFrame(function () {
      updateTimers();
      mutationScheduled = false;
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ─── Init ─────────────────────────────────────────────────────────────────
  fillAll();
  setInterval(updateTimers, 1000);

})();


